export default {
  id: (state) => state.id,
  postUuid: (state) => state.postUuid,
  name: (state) => state.name,
  folderId: (state) => state.folderId,
};
